import { Tokens } from '@/assets/tokens'
import { Calendar } from '@icon-park/react'
import styled from 'styled-components'

export const DatePickerContainer = styled.div`
  width: 100%;
  min-width: 130px;
  max-width: 140px;

  /* INPUT */
  .MuiPickersInputBase-root {
    width: 100%;
    height: 3.25rem;
    padding: 0 16px;
    border-radius: 10px;
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-start;
    align-items: center;
    column-gap: 10px;
    background-color: #f3f4f8;
    border: none;
    gap: 8px;
  }

  .MuiOutlinedInput-root {
    padding-right: 8px;
  }

  .MuiPickersOutlinedInput-notchedOutline {
    border: 0 !important;
  }

  .MuiButtonBase-root:hover {
    background-color: transparent;
  }

  /* POPPER (calendar container) */
  .MuiPaper-root {
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  /* HEADER (topo verde) */
  .MuiPickersCalendarHeader-root {
    background-color: #01c38d;
    color: white;
    border-bottom: none;
  }

  .MuiPickersCalendarHeader-label {
    color: white;
    font-weight: 500;
  }

  /* BOTÕES (setas) */
  .MuiPickersArrowSwitcher-root button {
    color: white;
  }

  /* DIAS */
  .MuiPickersDay-root {
    font-size: 13px;
  }

  /* DIA SELECIONADO */
  .MuiPickersDay-root.Mui-selected {
    background-color: #01c38d !important;
    color: white;
  }

  /* HOVER */
  .MuiPickersDay-root:hover {
    background-color: #e6f7f1;
  }

  /* DIA EM FOCO (keyboard) */
  .MuiPickersDay-root.Mui-focusVisible {
    background-color: rgba(1, 195, 141, 0.5);
  }
`

export const InputContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: ${Tokens.HeightInput};
  padding: 0 10px 0 12px;
  border-radius: ${Tokens.RadiusInput};
  background-color: ${Tokens.ColorBackground};
  cursor: pointer;

  &:hover {
    background-color: ${Tokens.ColorHover};
  }

  &:focus-within {
    border-color: #01c38d;
    box-shadow: 0 0 0 2px rgba(1, 195, 141, 0.2);
  }
`

export const Input = styled.input`
  flex: 1;
  border: none;
  background: transparent;
  outline: none;
  font-size: 13px;
  color: ${Tokens.ColorTextPrimary};
  cursor: pointer;
  padding-left: 20px;
  padding-right: 8px;
  width: 100%;

  &::placeholder {
    color: ${Tokens.ColorTextTertiary};
  }
`

export const CalendarIcon = styled(Calendar)`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: ${Tokens.ColorUIPrimary};
`
